import { render } from "./ActionsPage.vue?vue&type=template&id=3e6264b0"
import script from "./ActionsPage.vue?vue&type=script&lang=js"
export * from "./ActionsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__